var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 152.1 113.4",
        width: "100%",
        height: "100%",
      },
    },
    [
      _c("defs"),
      _c("g", { staticClass: "Layer_2", attrs: { "data-name": "Layer 2" } }, [
        _c(
          "g",
          { staticClass: "Layer_1-2", attrs: { "data-name": "Layer 1" } },
          [
            _c("path", {
              staticClass: "card-back",
              attrs: {
                fill: "#fff",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M13 35.2h103.2A5.7 5.7 0 01122 41v60.6a5.7 5.7 0 01-5.8 5.6H13a5.7 5.7 0 01-5.8-5.6V40.9a5.7 5.7 0 015.8-5.7z",
              },
            }),
            _c("path", {
              staticClass: "card-front",
              attrs: {
                fill: "#ccecf9",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M6.2 41.3h103.2a5.7 5.7 0 015.8 5.6v60.6a5.7 5.7 0 01-5.8 5.6H6.2a5.7 5.7 0 01-5.8-5.6V46.9a5.7 5.7 0 015.8-5.6z",
              },
            }),
            _c("circle", {
              staticClass: "badge-back cls-3",
              attrs: { cx: "117.4", cy: "34.7", r: "30" },
            }),
            _c("path", {
              staticClass: "card-loops cls-3",
              attrs: {
                d:
                  "M37.3 79h9c5.5-.2 10.3-1.4 13.5-3.4 3.7-2.2 4.5-4.7 4.6-7.8-.8-11.4-9.4-12.1-11.2-12.1-6.9 0-12.5 12-15.9 23.3zm-9 0h9.1c-3.4-11.4-9-23.2-15.8-23.3-3.2.1-10.6 1.6-11.3 12 0 3.2 1 5.7 4.6 7.9 3.2 2 8 3.2 13.4 3.4z",
              },
            }),
            _c("path", {
              staticClass: "front-lines",
              attrs: {
                fill: "none",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".5",
                d:
                  "M52.1 53.1c1.9 0 10.5.8 11.2 12 0 3.3-.9 5.7-4.5 8-3.3 2-8 3.1-13.5 3.3h-9c3.4-11.3 9-23.3 15.8-23.3zM27.3 76.4h9.1C33 65 27.4 53.2 20.6 53.1c-3.3.1-10.6 1.6-11.3 12 0 3.3.9 5.7 4.5 8 3.3 1.9 8 3.1 13.5 3.3zM51 91L36.4 76.4 22.1 92m14-51v71.7m79.1-35.8H.2",
              },
            }),
            _c("path", {
              staticClass: "star-badge",
              attrs: {
                fill: "#fad08c",
                stroke: "#7e7e7e",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": ".7",
                d:
                  "M150.1 29.1a10.4 10.4 0 01.5 10.4 12.4 12.4 0 00-1.4 6 10.4 10.4 0 01-5.2 9.1 13.7 13.7 0 00-5.4 5.7 10.4 10.4 0 01-8.8 5.7 12.2 12.2 0 00-5.9 1.7 10.4 10.4 0 01-10.4.1A13.7 13.7 0 00106 66a10.4 10.4 0 01-9.3-4.8A12.4 12.4 0 0092 57a10.4 10.4 0 01-5.3-9 13.8 13.8 0 00-2.2-7.6 10.4 10.4 0 01-.5-10.4 12.4 12.4 0 001.5-6 10.4 10.4 0 015.1-9.1 13.7 13.7 0 005.4-5.7 10.4 10.4 0 018.8-5.7 12.4 12.4 0 005.9-1.7 10.4 10.4 0 0110.4 0 13.8 13.8 0 007.7 1.7 10.4 10.4 0 019.3 4.9 12.3 12.3 0 004.4 4.2 10.4 10.4 0 015.3 9A13.8 13.8 0 00150 29zm-32.7 33.7a28.1 28.1 0 10-28.1-28 28.1 28.1 0 0028 28m17.2-32h-12.6a.7.7 0 01-.7-.4l-3.8-12-4 12a.7.7 0 01-.6.4h-12.5l10.1 7.4a.7.7 0 01.3.8l-4 12 10.3-7.4a.7.7 0 01.8 0L128 51l-4-12a.7.7 0 01.3-.8z",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }